export default __webpack_public_path__ + "static/media/ql_05.559fe4fb.png";